module.exports = __webpack_public_path__ + "static/media/20-speaker_profile.da9f2d70.webp";